import React from 'react'
import SiteNav from './src/components/SiteNav'
import ApplicationStateProvider from './src/context/ApplicationState'

export const wrapRootElement = ({ element }) => {
  return (
    <ApplicationStateProvider>
      <SiteNav />
      {element}
    </ApplicationStateProvider>
  )
}

export const onRouteUpdate = () => {
  try {
    navigator.serviceWorker.getRegistration().then(reg => {
      reg && reg.update()
    })
  } catch (err) {
    // FALLBACK: probably an in app iOS browser
    function reqListener () {
      let etag = this.getResponseHeader('etag')
      const cachedEtag = window.localStorage.getItem('cached-etag')
      // if the sw file has changed cache the new etag and reload
      if (etag != cachedEtag) {
        window.localStorage.setItem('cached-etag', etag)
        window.location.reload(true)
      }
    }

    let req = new XMLHttpRequest()
    req.addEventListener('load', reqListener)
    req.open('GET', `${window.location.origin}/sw.js`)
    req.send()
  }
}

export const onServiceWorkerUpdateReady = () => {
  // manual reload for PWAs
  window.location.reload(true)
}
